import React from 'react';
import { Field } from 'react-final-form';
import PhoneField from 'components/PhoneField';
import validations from 'validations';

type PhoneFieldWrapperProps = {
  name?: string;
  disabled?: boolean;
  required?: boolean;
  showInitialError?: boolean;
  verified?: boolean;
  onVerification?: () => void;
};

const PhoneFieldWrapper: React.FC<PhoneFieldWrapperProps> = (props) => {
  const {
    name = 'phone',
    disabled = false,
    required = false,
    showInitialError = false,
    verified = false,
    onVerification,
    ...rest
  } = props;

  return (
    <Field
      {...rest}
      name={name}
      component={PhoneField}
      disabled={disabled}
      required={required}
      showInitialError={showInitialError}
      verified={verified}
      onVerification={onVerification}
      validate={validations.composeValidators(
        required ? validations.phoneRequired() : null,
        validations.phone(),
      )}
    />
  );
};

export default PhoneFieldWrapper;
